interface GiveawayAsset {
  id: number;
  name: string;
  description: string;
  image_path: string;
  price: number;
  category: string;
  reward_id: string;
  status: 'claimed' | 'issuedtomarketors' | 'notclaimed';
  created_at: string;
}

interface ViewGiveawayAssetModalProps {
  isOpen: boolean;
  onClose: () => void;
  asset: GiveawayAsset | null;
}

const ViewGiveawayAssetModal = ({ isOpen, onClose, asset }: ViewGiveawayAssetModalProps) => {
  if (!isOpen || !asset) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-1000">
      <div className="gothic-panel w-full max-w-md">
        <h2 className="gothic-heading">View Giveaway Asset</h2>
        <div className="space-y-4">
          {asset.image_path && (
            <img
              src={`${process.env.REACT_APP_API_URL}/api/files/${asset.image_path}`}
              alt={asset.name}
              className="w-full h-auto mb-4 rounded"
            />
          )}
          <p className="gothic-text-silver"><strong className="gothic-text-gold">ID:</strong> {asset.id}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Name:</strong> {asset.name}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Description:</strong> {asset.description}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Price:</strong> ${asset.price.toFixed(2)}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Category:</strong> {asset.category}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Reward ID:</strong> {asset.reward_id}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Status:</strong> {asset.status}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Created At:</strong> {new Date(asset.created_at).toLocaleString()}</p>
          <div className="flex justify-end">
            <button onClick={onClose} className="gothic-button">Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewGiveawayAssetModal;
